module.exports = "<app-resume-main></app-resume-main>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/intro/intro.component.html
// module id = ./src/app/main/intro/intro.component.html
// module chunks = main